module.exports = __webpack_public_path__ + "media/src/img/insta-icon-blue-61665cbfb41a5710ed8c7bb3fb3145ad.svg";